import { Component, Input } from '@angular/core';
import { PopoverService } from './popover.service';

@Component({
  selector: 'app-custom-delete-popover',
  templateUrl: './custom-delete-popover.component.html',
  styleUrls: ['./custom-delete-popover.component.scss']
})
export class CustomDeletePopoverComponent {
  @Input() popoverIndex!: number;
  @Input() confirmCallback!: (value: any) => any;

  constructor(private popoverService: PopoverService) {}

  closePopover(): void {
    this.popoverService.hidePopover(this.popoverIndex);
  }

  confirmAction():any {
    this.confirmCallback(this.popoverIndex);
    this.popoverService.hidePopover(this.popoverIndex);
  }
}
